// extracted by mini-css-extract-plugin
export default {"emptyMarket":"styles_emptyMarket__Zulsc","emptyMarket__singleLine":"styles_emptyMarket__singleLine__OCB6Z","emptyMarket__first":"styles_emptyMarket__first__lDbJr"};